import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { guides } from "../../data/guides";
import "./guides.css";

export default function Guides() {
  const imageMap = {
    "ziyarat-of-imam-hussain-karbala-guide":
      "https://ziyaratguide.com/wp-content/uploads/2025/09/ImamHussain2.avif",
    "imam-hussain-family-tree-quotes-lessons":
      "https://ziyaratguide.com/wp-content/uploads/2025/09/ImamHussain3.avif",
  };

  const defaultOG =
    "https://ziyaratguide.com/wp-content/uploads/2025/09/ImamHussain2.avif";

  return (
    <>
      <Helmet>
        <title>Guides | Ziyarat Guide</title>
        <meta
          name="description"
          content="Explore practical, easy-to-read guides for pilgrims visiting Karbala, Najaf, and other sacred sites. Learn travel tips, etiquettes, and spiritual insights."
        />
        <meta property="og:title" content="Guides | Ziyarat Guide" />
        <meta
          property="og:description"
          content="Discover curated guides to plan your ziyarat to Karbala and Najaf with confidence — from travel logistics to spiritual preparation."
        />
        <meta property="og:image" content={defaultOG} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="container">
        <header className="guides-header">
          <h1>Guides</h1>
          <p className="muted">
            Practical, focused write-ups for pilgrims and planners.
          </p>
        </header>

        <div
          className={`guides-grid ${guides.length < 3 ? "guides-center" : ""}`}
        >
          {guides.map((post, i) => (
            <motion.article
              key={post.slug}
              className="guide-card"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35, delay: i * 0.07 }}
              whileHover={{ scale: 1.03 }}
            >
              <Link to={`/guides/${post.slug}`} className="guide-link">
                <div className="guide-cover-wrap">
                  <img
                    src={imageMap[post.slug] || post.cover || defaultOG}
                    alt={post.title}
                    className="guide-cover"
                    loading="lazy"
                  />
                </div>
                <div className="guide-meta">
                  <h2 className="guide-title">{post.title}</h2>
                  <p className="guide-excerpt">{post.excerpt}</p>
                  <div className="guide-tags">
                    {post.tags?.map((t) => (
                      <span key={t} className="tag">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </>
  );
}
